const STICKY_SELECTORS = [".v-app-bar--fixed", ".pasien-flying-bar"];

function stickyOffset(): number {
  return STICKY_SELECTORS.reduce((total, selector) => {
    const el = document.querySelector(selector) as HTMLElement | null;
    return el && el.offsetHeight ? total + el.offsetHeight : total;
  }, 0);
}

export function scrollTabIntoView(el: Element | null | undefined): void {
  if (typeof window === "undefined" || !el) {
    return;
  }
  const target = el as HTMLElement;
  if (typeof target.getBoundingClientRect !== "function") {
    return;
  }

  const offset = stickyOffset();
  const top = target.getBoundingClientRect().top;
  if (top >= offset) {
    return;
  }

  window.scrollTo({
    top: window.pageYOffset + top - offset,
    behavior: "smooth",
  });
}
